import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { CalendarService } from '@frontend/sports/calendar/feature';
import { CountItem } from '@frontend/sports/common/core/data-access/sport-model';
import { EventListService } from '@frontend/sports/event-list/feature';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SportListOverviewResolver {
    private service = inject(EventListService);
    private calendar = inject(CalendarService);

    resolve(route: ActivatedRouteSnapshot): Observable<CountItem[]> {
        // needed for betstation - there we have in-30-minutes
        const context = (route.params['context'] || '').replace(/-/gi, '');

        const interval = this.calendar.getTimeInterval(context) || {};

        return this.service.getSportList(interval.from, interval.to);
    }
}
